import { toPersianDigit } from '@/helpers/utils';

type NumberRendererProps = {
  text?: number | string | null;
};

// نمایش اعداد به صورت وسطچین در جدول
const NumberRenderer = ({ text }: NumberRendererProps) => {
  const withSeparators = text?.toString()?.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') ?? '';
  return (
    <div className="w-100 d-flex justify-content-center ">
      <div>{toPersianDigit(withSeparators)}</div>
    </div>
  );
};

export default NumberRenderer;
